import React from 'react';

import VideoContentItem, {
	VideoContentItemProps,
} from '@components/report/content-items/video-content-item/VideoContentItem';
import NoDataSection from '@components/report/no-data-section/NoDataSection';
import SnapCarousel from '@shared/snap-carousel/SnapCarousel';
import { lackOfPermissionClass } from '@components/report/style.css';

export interface VideoContentYtProps {
	items?: VideoContentItemProps[];

	isLoading?: boolean;
	isError?: boolean;
	lackOfPermission?: boolean;
}

const VideoContentYt = ({
	isLoading,
	isError,
	lackOfPermission,
	...props
}: VideoContentYtProps) => {
	const status = { isLoading, isError, lackOfPermission };
	const available = !isLoading && !isError && !lackOfPermission;
	const items = !available
		? new Array(20).fill({} as VideoContentItemProps)
		: props.items ?? [];

	if (!available || (available && items.length > 0))
		return (
			<SnapCarousel
				className={lackOfPermission ? lackOfPermissionClass : ''}
				items={items?.map((item, idx) => (
					<VideoContentItem key={idx} idx={idx} {...item} {...status} />
				))}
			/>
		);
	else return <NoDataSection />;
};

export default VideoContentYt;
